$(document).ready(function(){
	var timeout = null; 
	function getAddressList(inputClass, inputZipClass, datalistId){
		$(inputClass).on("input", function () {
			var zipCode = $(datalistId + ' [value="' + $(this).val() + '"]').data('zipcode');
			if(zipCode === undefined){
				if(timeout !== null) {
					clearTimeout(timeout) 
				}
				var options = {};
				var value = $(this).val();
				options.url = "/ajax/locations/";
				options.type = "GET";
				options.data = { "q": value};
				options.dataType = "json";
				options.success = function (data) {
					for(var i=0;i<data.length;i++){
						$(datalistId).append("<option data-zipcode='" + data[i].zip_code + "' value='" + data[i].name + "'>" + data[i].name + " - " + data[i].zip_code + " - " + data[i].county + "</option>");
					}
				};
	
				timeout = setTimeout(function() { 
					clearTimeout(timeout)
					$(datalistId).empty();
					if(value.length > 2){
						$.ajax(options);
					}
				}, 300)
	
				$(datalistId).hide()
				setTimeout(function(){
					$(datalistId).show()
				}, 300);
			} else {
				$(inputZipClass).val(zipCode);
			}
		});
	}

	// function fillZipCode2(inputPlaceClass, inputZipClass, datalistId  ){
	// 	$(inputPlaceClass).on("change", function () {
	// 		console.log($(this))
	// 		var zipCode = $(datalistId + ' [value="' + $(this).val() + '"]').data('zipcode');
	// 		if(parseInt(zipCode) !== parseInt($(inputZipClass).val())){
	// 			isSelected = true;
	// 			clearTimeout(timeout)
	// 			timeout = null;
	// 			$(inputZipClass).focus()
	// 			setTimeout(function() {
	// 				isSelected = false
	// 			}, 10000);
	// 		}
	// 	});
	// }

	// function fillZipCode(){
	// 	$(".js-demandAddressPlace").on("change", function () {
	// 		isSelected = true;
	// 		$(".js-demandAddressZipcode").val($('#demandAddressList [value="' + $(this).val() + '"]').data('zipcode'));
	// 		setTimeout(function() {
	// 			isSelected = false
	// 		}, 300);
	// 	});
	// 	$(".js-offerAddressPlace").on("change", function () {
	// 		isSelected = true;
	// 		$(".js-offerAddressZipcode").val($('#offerAddressList [value="' + $(this).val() + '"]').data('zipcode'));
	// 		setTimeout(function() {
	// 			isSelected = false
	// 		}, 300);
	// 	});
	// 	$(".js-estimateAddressPlace").on("change", function () {
	// 		isSelected = true;
	// 		$(".js-estimateAddressZipcode").val($('#estimateAddressList [value="' + $(this).val() + '"]').data('zipcode'));
	// 		setTimeout(function() {
	// 			isSelected = false
	// 		}, 300);
	// 	});
	// }
	

	function estimateTabs(){

		var estimateTabs = [];
		var estateTypeOptions = [];

		$(".estimate-tabs .estimate-tab").map(function(i, e){
			estimateTabs.push($(e));
			$(this).attr("data-index", i);
		});

		$(estimateTabs[0]).addClass("active");

		$(".estate-type-select option").map(function(i, e){
			estateTypeOptions.push($(e));
			$(this).attr("data-index", i);
		});

		$(".estate-type-select").on("change", function(){
			var index = $(this).prop("selectedIndex");
			$(".estimate-tabs .estimate-tab").removeClass("active");
			$(estimateTabs[index]).addClass("active");
		});

		$(".select .state-estimates").each(function(){
			var defaultState = $(this).parent().find("option:selected").text();
			$(this).html(defaultState);
			$(".select select").on("change", function(){
				$(this).parent().find(".state-estimates").html($(this).find("option:selected").text())
			});
		});
	}

	function formSubmit(){
		$("form").on("submit", function(e){
			var purposeForm = $("#purpose-form");
			var purposeData = purposeForm.serialize();
			var hiddenInput = purposeForm.serializeArray().find(item => {
				return item.name === 'purpose-purpose';
			}).value;
			var form = $(this);
			e.preventDefault();

			grecaptcha.ready(function() {
				grecaptcha.execute(captcha_key, {action: 'submit'}).then(function(token) {
					let grecaptchaInput = document.getElementById(`id_${hiddenInput}-grecaptcha`);
        	grecaptchaInput.value = token;

        	var validated = true;
					var selected = true;
					var title = true;

					$(form).find(".single-input:not(.not-required) .input").each(function(i, e){
						if($(e).val().length < 1){
							$(e).parent().addClass("error");
							validated = false;
						}
						else{
							$(e).parent().removeClass("error");
						}
					});

					$(form).find(".single-input .select").each(function(i, e){
						if($(e).prop("checked") == false){
							$(e).parent().addClass("error");
							selected = false;
						}
						else{
							$(e).parent().removeClass("error");
						}
					});

					if($(".input.title").val().length < 1){
						$(".input.title").parent().addClass("error");
						title = false;
					}
					else{
						$(".input.title").parent().removeClass("error");
					}

					if(validated == true && selected == true && title == true){
						$(form).find(".error-message").removeClass("active");
						$.ajax({
							type: $(form).attr("method"),
							url: $(form).attr("action"),
							data: $(form).serialize() + '&' + purposeData,
							success: function(data){
								$(".modal.form-submitted").addClass("active");
								$(form)[0].reset();
								$(purposeForm)[0].reset();
							},
							error: function(data){

							}
						});
					}
					else{
						$(form).find(".error-message").addClass("active");
					}
				});
			});
		});
	}

	function closeModal(){
		$(".close, .close-button").on("click", function(){
			$(".modal").removeClass("active");
		});
	}

	$(".disabled-first").each(function(i, e){
		$($(e).find("select option")[0]).attr("disabled", "disabled");
	});

	estimateTabs();
	formSubmit();
	closeModal();
	getAddressList('.js-demandAddressPlace', '.js-demandAddressZipcode', '#demandAddressList');
	getAddressList('.js-offerAddressPlace', '.js-offerAddressZipcode', '#offerAddressList');
	getAddressList('.js-estimateAddressPlace', '.js-estimateAddressZipcode', '#estimateAddressList');
	// fillZipCode();
});


// WEBPACK FOOTER //
// src/js/bundle/estimates.js